import React from 'react'
import { useHistory } from 'react-router-dom';
import { ResetPageWrapper } from '../PasswordReset/style';
import { CentralContainer, CheckEmailHeader, CheckMailSubtitle, GobackFrom404, SadIcon } from '../UserLogin/Login.elements';

const YouLost = () =>{
    const history = useHistory();
    return(
        <>
        <ResetPageWrapper>
                 <CentralContainer>
                     <SadIcon/>
                    <CheckEmailHeader>
                 Mhh! Kuna kitu hakiko sawa
                    </CheckEmailHeader>
                 <CheckMailSubtitle>
                 Tumeshindwa kuupata ukurasa unaotafuta. 
                 </CheckMailSubtitle>

                    <GobackFrom404 onClick={() => history.push('../')}>Rudi Mwanzo</GobackFrom404>
                    <CheckMailSubtitle> Kama tatizo litaendelea tupigie kwa msaada <strong>0747-636-516</strong> </CheckMailSubtitle>
                 </CentralContainer>
        </ResetPageWrapper>
        </>
    )
}

export default YouLost;